<html>

<head>
  <title>SecureNow App-Terms</title>
</head>

<body>
  <div class="SNLogo">
    <a title="Return Home" href="/"> <img alt="SecureNow"
        src="https://blog.securenow.in/wp-content/themes/colormag/img/securenow-logo.png" title="SecureNow">
    </a>
  </div>
  <div class=SNSection>
    <header class="SNHeader">
      <h4 class=SNHeading>Terms and Conditions:</h4>
    </header>


    <p class="SNTerms">By accepting these terms and conditions, I confirm consent to being a member of SecureNow
      Tech Services'
      database.</p>

    <p class="SNTerms">I can access the SecureNow App available at <a class="applink"
        href="https://securenow.app">https://securenow.app</a> for obtaining wellness products, risk-related
      knowledge and products, hospital locator, and health insurance E-cards as applicable.</p>

    <p class="SNTerms">I/We hereby declare, on my behalf and on behalf of all persons proposed to be insured, that
      the statements,
      answers and/ or particulars given by me are true and complete in all respects to the best of my knowledge
      and
      that I/We am/are authorized to propose on behalf of these other persons.</p>

    <p class="SNTerms">I understand that the information provided by me will form the basis of the insurance policy,
      is subject to the
      Board approved underwriting policy of the insurance company and that the policy will come into force only
      after
      full receipt of the premium chargeable.</p>

    <p class="SNTerms">I/We further declare that I/We will notify in writing any change occurring in the occupation
      or general health
      of the life to be insured/proposer after the proposal has been submitted but before communication of the
      risk
      acceptance by the company.</p>

    <p class="SNTerms">I/We declare and consent to the company seeking medical information from any doctor or from a
      hospital who at
      any time has attended on the life to be insured/proposer or from any past or present employer concerning
      anything which affects the physical or mental health of the life to be assured/proposer and seeking
      information
      from any insurance company to which an application for insurance on the life to be assured/proposer has been
      made for the purpose of underwriting the proposal and/or claim settlement.</p>

    <p class="SNTerms">I/We authorize the company to share information pertaining to my proposal including the
      medical records for the
      sole purpose of proposal underwriting and/or claims settlement and with any Government and/or Regulatory
      authority.</p>
  </div>
</body>

</html>
